export default __webpack_public_path__ + "static/media/logo-red.9ee35ad3.svg";